exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Custom styling for form layout */\n.v-label[data-v-301d0692] {\n  opacity: 1 !important;\n  color: rgb(var(--v-theme-on-surface)) !important;\n}\n\n/* Ensure proper spacing in form */\n[data-v-301d0692] .v-field {\n  font-size: 14px;\n}\n[data-v-301d0692] .v-btn {\n  text-transform: none;\n}\n", ""]);

// exports
